import React, { useState, useEffect } from "react";

import { UserContext } from "./contexts/userContext";
import { BreadCrumbsContext } from "./contexts/breadCrumbsContext";
import { MoodsContext } from "./contexts/moodsContext";
import UserService from "services/UserService";

export default ({ children }) => {
  const userData = localStorage.getItem("user");
  const tokenData = localStorage.getItem("token");

  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(
    tokenData && userData ? true : false
  );
  const [breadCrumbs, setBreadCrumbs] = useState([]);
  const [moods, setMoods] = useState();
  const [buzzes, setBuzzes] = useState();

  useEffect(() => {
    if (!(tokenData && userData)) {
      return;
    }
    try {
      (async () => {
        const response = await UserService.getUserProfile();
        setUser({ ...response.data.data, token: tokenData });
      })();
    } catch (error) {
      console.log(error);
    }
    // eslint-disable-next-line
  }, [isAuthenticated]);

  return (
    <UserContext.Provider
      value={{
        user,
        setUser,
        isAuthenticated,
        setIsAuthenticated,
      }}
    >
      <BreadCrumbsContext.Provider
        value={{
          breadCrumbs,
          setBreadCrumbs,
        }}
      >
        <MoodsContext.Provider
          value={{
            moods,
            setMoods,
            buzzes,
            setBuzzes,
          }}
        >
          {children}
        </MoodsContext.Provider>
      </BreadCrumbsContext.Provider>
    </UserContext.Provider>
  );
};
